import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export interface FormFieldProps extends ChakraV3.FieldRootProps {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  extra?: React.ReactNode;
  optionalText?: React.ReactNode;
  fieldSet?: boolean;
}

export const FormField = (props: React.PropsWithChildren<FormFieldProps>) => {
  const {
    label,
    helperText,
    errorText,
    extra,
    optionalText,
    orientation,
    fieldSet,
    children,
    ...rest
  } = props;

  const isInvalid = !!errorText;

  // We handle orientation ourselves. The orientation done via
  // field is ugly.
  const stackProps: Partial<ChakraV3.StackProps> = {
    direction: orientation === 'horizontal' ? 'row' : 'column',
    align: orientation === 'horizontal' ? 'center' : undefined,
    w: 'full',
    gap: 1.5,
  };

  const Root = fieldSet ? ChakraV3.Fieldset.Root : React.Fragment;

  return (
    <Root>
      <ChakraV3.Field.Root invalid={isInvalid} {...rest}>
        <ChakraV3.Stack {...stackProps}>
          <ChakraV3.HStack>
            <ChakraV3.Field.Label>
              {label}
              <ChakraV3.Field.RequiredIndicator fallback={optionalText} />
            </ChakraV3.Field.Label>
            <ChakraV3.Spacer />
            {extra}
          </ChakraV3.HStack>
          {children}
        </ChakraV3.Stack>
        {helperText && (
          <ChakraV3.Field.HelperText textWrap='auto'>{helperText}</ChakraV3.Field.HelperText>
        )}
        {errorText && <ChakraV3.Field.ErrorText>{errorText}</ChakraV3.Field.ErrorText>}
      </ChakraV3.Field.Root>
    </Root>
  );
};
